import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Analytics from 'APP_ROOT/services/analytics';
import Events from 'APP_ROOT/components/common/events';
import { strings } from 'APP_ROOT/localization';
import Selectors from 'APP_ROOT/data/settings/selectors';
import { loadSettings } from 'APP_ROOT/data/settings/actions';
import { SETTINGS_EVENTS_CONFIG_KEYS } from 'APP_ROOT/data/events';
import ErrorMessage from 'APP_ROOT/components/ErrorMessage';
import {Selectors as tagsSelectors} from 'APP_ROOT/data/tags';

import Protected from '../../components/common/protected';
import GlobalSettings, {
    ALL_MAIN_SECTIONS as RAVEN_SETTINGS_MAIN_SECTIONS,
    SUBSECTIONS_BY_MAIN_SECTION as RAVEN_SETTINGS_SUBSECTIONS_BY_MAIN_SECTION } from './GlobalSettings/GlobalSettings';
import FaceRecognition, {
    ALL_MAIN_SECTIONS as FACIAL_RECOGNITION_MAIN_SECTIONS,
    SUBSECTIONS_BY_MAIN_SECTION as FACIAL_RECOGNITION_SUBSECTIONS_BY_MAIN_SECTION } from './FaceRecognition/FacesSection';

const ALL_MAIN_SECTIONS = {
    ...RAVEN_SETTINGS_MAIN_SECTIONS,
    ...FACIAL_RECOGNITION_MAIN_SECTIONS, // FACES
};

const KNOWN_AI_EVENTS_CONFIG_KEYS = [ // list of event config keys for RAVEN_SETTINGS_SUBSECTIONS_BY_MAIN_SECTION
    ... SETTINGS_EVENTS_CONFIG_KEYS,
    "tailgating_detection" // tailgating_detection does not have a generic data/events configuration file b/c it is more complicated (thresholds settings)
];

const ravenSettingsSectionKeys = Object.keys(RAVEN_SETTINGS_MAIN_SECTIONS);
const facialRecognitionSectionKeys = Object.keys(FACIAL_RECOGNITION_MAIN_SECTIONS);
export class SettingsPage extends Component {

    state = {
        selectedSubSection: null,
    };

    componentDidMount() {
        Analytics.pageView();
        this.loadSettings();
    }

    componentDidUpdate(oldProps) {
        // on transition from loading to loaded or error, hide flying v
        if ((!oldProps.settingsLoaded && this.props.settingsLoaded)
            || (this.props.settingsError)) {
            this.hideFullscreenLoading();
        }
    }

    loadSettings = () => {
        if (!this.props.settingsLoaded) {
            this.showFullscreenLoading();
        }
        this.props.loadSettings();
    }

    showFullscreenLoading = () => {
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE));
    }

    hideFullscreenLoading = () => {
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    allRavensPlansSupportWiFi = (ravens) => {

        if (!ravens) {
            //console.warn("SettingsPage render+getHighestRavenAccessLevel while ravens undefined");
            return undefined;
        }

        for (var i = 0; i < ravens.length; i += 1) { // using basic for loop so I can return on WiFi not supported, immediately

            if (!ravens[i].hasOwnProperty("features")) {
                console.error("SettingsPage allRavensPlansSupportWiFi raven missing features property");
                continue;
            }
            if (!ravens[i]["features"].length) {
                console.error("SettingsPage allRavensPlansSupportWiFi raven has no supported features items");
                continue;
            }
            const wifiHotspot = ravens[i]["features"].find(feature => feature.name === "wifiHotspot");
            if (!wifiHotspot) {
                console.error("SettingsPage allRavensPlansSupportWiFi raven missing wifiHotspot feature");
            }

            if (!wifiHotspot.supported) {
                return false;
            }
        }
        return true;
    };

    render() {
        const {
            features,
            user,
            accountDetails,
            ravens,
        } = this.props;

        const baseSectionProps = {
            features,
            user,
        };

        const allRavensPlansSupportWiFi = this.allRavensPlansSupportWiFi(ravens);
        
        return (
            <div id="settingsPage" className="container settings-page">
                <div className="row">
                    <div className="col-12">
                        <h1 className="d-inline-block">{strings.settings}</h1>
                    </div>
                </div>
                {this.props.settingsError &&
                    <div className="row">
                        <div className="col-12">
                            <ErrorMessage error={this.props.settingsError} />
                        </div>
                    </div>
                }

                {features.global_settings ?
                    features.global_settings.section_available ?
                        <Protected resource="settings" action="read" gate={this.props.ravens && this.props.ravens.length > 0}>
                            <GlobalSettings
                                {...baseSectionProps}
                                accountDetails={accountDetails}
                                allRavensPlansSupportWiFi={allRavensPlansSupportWiFi}
                            />
                        </Protected>
                    :
                        null // global_settings explicitly not available for user type
                :
                    null // global_settings not configured
                }
                {features.facial_recognition &&
                    <FaceRecognition {...baseSectionProps} />
                }
            </div>
        );

    }
}

SettingsPage.propTypes = {
    user: PropTypes.object.isRequired,
    ravenConfigDataSource: PropTypes.object,
    features: PropTypes.object.isRequired,
    hiddenRavens: PropTypes.arrayOf(PropTypes.object),
    onShowcaseRavenChanged: PropTypes.func.isRequired,

    settingsLoaded: PropTypes.bool.isRequired,
    settingsError: PropTypes.object,
    loadSettings: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        tags: tagsSelectors.tags(state),
        tagsLoaded: tagsSelectors.loaded(state),
        settingsLoaded: Selectors.settingsLoaded(state),
        settingsError: Selectors.error(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.user.stage)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);
